import { leaderboardUsers } from "@/models/leaderboardUser.model";
import { FC, useEffect, useRef, useState } from "react";

import { formatGap } from "../../../../utils/formatRacingTime";
import LeaderboardItem from "../LeaderboardItem/LeaderboardItem";

const LatestResult: FC<{ data: leaderboardUsers[] }> = ({ data }) => {
  const [highlightedUser, setHighlightedUser] =
    useState<leaderboardUsers | null>(data[0]);

  const prevDataRef = useRef<leaderboardUsers[]>([]);
  const isFirstLoad = useRef(true);

  useEffect(() => {
    setHighlightedUser(data[0]);

    if (data.length > 0) {
      if (isFirstLoad.current) {
        isFirstLoad.current = false;
        prevDataRef.current = data;
        return;
      }

      const prev = prevDataRef.current;

      data.forEach((user) => {
        const oldUser = prev.find((u) => u.profile.uid === user.profile.uid);

        if (!oldUser) {
          setHighlightedUser(user);
        } else if (
          oldUser.userChallengeData.points !== user.userChallengeData.points
        ) {
          setHighlightedUser(user);
        }
      });

      prevDataRef.current = data;
    }
  }, [data]);

  if (!highlightedUser) return null;

  return (
    <LeaderboardItem
      item={highlightedUser}
      gap={formatGap(
        highlightedUser.userChallengeData?.points,
        data[0]?.userChallengeData?.points
      )}
    />
  );
};

export default LatestResult;
